import React, { Component } from "react";
import NavBar from "../components/NavBar";
import Sidebar from "./components/Sidebar";
import ServiceGallery from "./components/ServiceGallery"
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
class EarlyIntervention extends Component {
  render() {
    return (
      <div>
        {/* Navigation bar */}
        <NavBar />

        {/* breadcrumb */}
        {/*====================  breadcrumb area ====================*/}
        <div
          className="breadcrumb-area breadcrumb-bg"
          style={{
            backgroundImage: `url(assets/img/backgrounds/funfact-bg.jpg)`
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col">
                <div className="page-banner text-center">
                  <h1>Early Intervention & Child Development</h1>
                  <ul className="page-breadcrumb">
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li>
                      <a href={`${process.env.PUBLIC_URL}/services`}>
                        Services
                      </a>
                    </li>
                    <li>Early Intervention & Child Development</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*====================  End of breadcrumb area  ====================*/}

        <div className="page-wrapper section-space--inner--120">
          {/*Service section start*/}
          <div className="service-section">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 col-12 order-1 order-lg-2">
                  <div className="service-details">
                    {/* service gallery */}
                    <ServiceGallery />

                    <div className="content section-space--top--30">
                      <h2>Early Intervention & Child Development</h2>

                      <p>
                        Early intervention is a system of services and support provided to
                         infants and young children (birth to 6 years) who have developmental
                         delays, disabilities, or are at risk of developmental problems. The 
                         goal is to identify difficulties early and provide appropriate therapies 
                         and educational support to improve development.
                         </p>

                      <p>
                        Child Development refers to the process through which children grow and
                        develop physical, cognitive, language, social, and emotional skills from
                        birth through adolescence. Development is influenced by genetics,
                        environment, nutrition, education, and life experiences. Early support helps
                        children build strong foundations for lifelong learning and independence.
                      </p>

                      <div className="row">

                        <div className="col-lg-6 col-12 section-space--top--30">
                          <h3>Who Can Benefit?</h3>

                          <ul>
                            <li>Children with developmental delays</li>
                            <li>Autism Spectrum Disorder (ASD)</li>
                            <li>Cerebral Palsy</li>
                            <li>ADHD</li>
                            <li>Speech and language delays</li>
                            <li>Learning disabilities</li>
                          </ul>
                        </div>

                        <div className="col-lg-6 col-12 section-space--top--30">
                          <h3>Our Goals</h3>

                          <ul>
                            <li>Promote physical and cognitive development</li>
                            <li>Improve communication skills</li>
                            <li>Develop social and emotional abilities</li>
                            <li>Encourage independence</li>
                            <li>Prepare children for school and daily life</li>
                            <li>Support families through early guidance</li>
                          </ul>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-12 order-2 order-lg-1">
                  <Sidebar />
                </div>
              </div>
            </div>
          </div>
          {/*Service section end*/}
        </div>

        {/* Footer */}
        <Footer />

        {/* Mobile Menu */}
        <MobileMenu />
      </div>
    );
  }
}

export default EarlyIntervention;
